interface UserStoreLike {
    formatUserPermissions: string[]
}

export default function checkPermissions(permissions: string[] | undefined, userStore: UserStoreLike): boolean {
    const requiredPermissions = permissions ?? []
    const userPermissions = userStore.formatUserPermissions

    return !!userPermissions && requiredPermissions.some((permission) => userPermissions.includes(permission))
}

interface UserPermission {
    id: string
    isActive: boolean
}

export function checkPermissionsOfLimitCondition(
    userPermissions: UserPermission[],
    validatePermissions: string[]
): boolean {
    if (validatePermissions.length === 0) {
        return true
    }

    for (const permissionId of validatePermissions) {
        const userPermission = userPermissions.findLast((permission) => {
            return permission.id === permissionId
        })

        if (userPermission?.isActive) {
            continue
        }

        return false
    }

    return true
}
